import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  image?: IGatsbyImageDataObject
}
function PatternsIntroPart4(props: Props) {
  const { image } = props
  return (
    <div className=''>
      <BackgroundImageV5
        bgSrcClasses='bg-inheritPos md:bg-center'
        bgImageClasses='bgImageClasses col-span-full relative h-[300px] md:block md:absolute md:h-full'
        innerDivClasses='et-grid-basic lg:min-h-[auto]'
        gatsbyDataImg={image?.gatsbyImageData}
        showBlurImage={true}>
        <div className='relative col-span-2 col-start-2 pb-12 z-3 md:col-start-8 md:col-span-6 md:py-12 lg:col-start-8 lg:col-span-6 lg:py-20 xl:col-start-9 xl:col-span-5 xxl:py-36 xxl:mr-[-60px]'>
          <h2 className='mt-8 text-2xl font-sentinel__SemiBoldItal text-rusted-900 md:mt-0 xl:text-4xl'>
            Following this process, you'll be outputting new designs in half the time with the confidence your repeat patterns are perfectly seamless.
          </h2>
          <p className='py-8 text-3xl font-semibold md:py-10 text-rusted-400 xl:text-2xl xxl:py-16'>
            We're making pattern creation in Procreate share-with-the-world fun, and we're doing it without a single software subscription.
          </p>
          <p className='text-3xl font-sentinel__SemiBoldItal text-rusted-900'>
            Catch ya later, Adobe 👋
          </p>
        </div>
      </BackgroundImageV5>

    </div>
  )
}

export default PatternsIntroPart4
